export default __webpack_public_path__ + "static/media/boxing-shorts.eed5edbd.png";